/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Input from '../../Common/ui/input'
import { useForm } from 'react-hook-form'
import SaveCancelButton from '../../Common/ui/SaveCancelButton'
import { Button } from '../../Common/ui/button'
import { Card, CardContent } from '../../Common/ui/card'
import { RadioGroup, RadioGroupItem } from '../../Common/ui/radio-group'
import SelectInput from '../../Common/ui/selectInput'
import Textarea from '../../Common/ui/textArea'
import { IoAdd } from 'react-icons/io5'
import MultiFileSelect from '../../Common/ui/MultiSelectFile'
import { useTranslation } from 'react-i18next'
import Heatmap from 'react-heatmap-grid'
import { Dialog, DialogActions, DialogContent, DialogTitle, Chip, Tooltip, DialogContentText } from '@mui/material'
import * as RiskTypes from '../../Entities/RiskTypes'
import * as IssueTypes from '../../Entities/IssueTypes'

import * as MeetingTypes from '../../Entities/MeetingTypes'
import DatePickerInput from '../../Common/ui/DatePickerInput'
import Loading from '../../Common/ui/Loading'
import useCustomNavigate from '../../Common/ui/Navigate'
import * as RoutePath from '../../Entities/RoutePath'
import { cn, convertFileToBase64, inputValidation } from '../../lib/utils'
import AddOnTable from 'src/Common/ui/AddOnTable'
import '../../Styles/AddRisk.css'
import { RiDeleteBin5Line } from 'react-icons/ri'
import MultiSelectInput from 'src/Common/ui/MultiSelect'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router'
import * as Endpoints from '../../Entities/EndPoints'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
import MultiSelectInputDisable from 'src/Common/ui/MultiSelectDisable'
import { INITIATE } from 'src/Entities/CommonEntities'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import Axios from 'src/Axios'
import { useRiskStore } from '../Risk/Store/RiskStore'
import { useIssueStore } from './store/IssueStore'

const AddIssue = ({ isEditTrue, riskInfoData, handleApprove, ref, statusEnum, handleReject, editFormData, setIsEditTrue, riskInfo }) => {
    const { RiskDetailsById, getRidkDetailsById } = useRiskStore()
    const RiskDetailsByIdLoading = useRiskStore((state) => state.RiskDetailsByIdLoading)
    const queryParams = new URLSearchParams(location.search)
    const riskId = queryParams.get('riskId')
    useEffect(() => {
        if (riskId) {
            getRidkDetailsById(Number(riskId), loginId)
            setInternalExternal('Risk')
        }
    }, [riskId])
    const getDepartmentId = JSON.parse(localStorage.getItem('departmentId'))
    const instance = Axios.getInstance()
    const { register, handleSubmit, formState: { errors, isSubmitting, isLoading }, setValue, clearErrors, setError, control, trigger } = useForm({
        mode: 'onChange',
        shouldUnregister: false, // Prevent fields from being unregistered
        defaultValues: {
            title: editFormData?.Title || '',
            description: editFormData?.Description || '',
            identifiedOn: editFormData?.IdentifiedOn || '',
            type: editFormData?.Type || '',
            category: editFormData?.Category || '',
            riskOwner: editFormData?.RiskOwner || '',
            impactedDepartnments: editFormData?.ImpactedDepartnments || [getDepartmentId],
            impactOfRisk: editFormData?.ImpactOfRisk || '',
            issueScore: editFormData?.issueScore || [],
            mitigationTasks: editFormData?.mitigationTasks || [{ id: 0, task: '', startDate: '', endDate: '', status: 5 }]
        }
    })
    const [ isSubmitted, setIsSubmitted ] = useState(false)
    const { t } = useTranslation()
    const [ internalExternal, setInternalExternal ] = useState('New')
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ formData, setformData ] = useState({})
    const [ heatMapSelection, setheatMapSelection ] = useState(true)
    const [ issueScore, setIssueScore ] = useState([])
    const [ initialIssueScore, setinitialIssueScore ] = useState({ impact: null, Probability: null, RiskScore: null })
    const [ open, setOpen ] = React.useState(false)
    // const { CreateRisk } = useRiskStore()
    const { CreateIssue } = useIssueStore()
    const [ loading, setLoading ] = useState(false)
    const customNavigate = useCustomNavigate()
    const navigate = useNavigate()
    const [ issueTypes, setIssueTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ openWithdrawnPopup, setOpenWithdrawnPopup ] = useState(false)
    const [ scoringLevel, setScoringLevel ] = useState(RiskTypes.KISS_METHOD_ID)
    const [ mitigationTasks, setMitiationTasks ] = useState([
        { id: 0, task: '', startDate: '', endDate: '', status: 5 }
    ])
    const [ isRiskType, setIsRiskType ] = useState(true)
    const [ isMitigationTasks, setMitigationTasks ] = useState(true)
    const orgId = localStorage.getItem('orgId')
    const loginId = localStorage.getItem('userId')
    const userName = localStorage.getItem('userName')
    const headerArray = [ 'S.No', 'Task', 'Start Date', 'End Date', 'Action' ]
    const handleCheckRadioBox = (e) => {
        setInternalExternal(e)
    }
    const handleClose = () => {
        setOpen(false)
        setinitialIssueScore({ Priority: null, Severity: null, RiskScore: null })
    }

    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])
    useEffect(() => {
        if (location.pathname.includes('add-issue')) {
            setformData({
                ImpactedDepartnments: [getDepartmentId]
            })
            setValue('ImpactedDepartnments', getDepartmentId)
        }
    }, [location.pathname])
    useEffect(() => {
        if (isEditTrue) {
            setformData(editFormData)
            setMitiationTasks(editFormData?.mitigationTasks?.map((mapData, mapIdx) => {
                if (!mapData?.actions || mapData?.actions === null) {
                    return { ...mapData, newUpdate: true }
                } else {
                    return mapData
                }
            }))
            setIssueScore(editFormData?.issueScore)
            setInternalExternal(editFormData?.internalExternal)

            setValue('Title', editFormData?.Title || '')
            setValue('Description', editFormData?.Description || '')
            setValue('IdentifiedOn', editFormData?.IdentifiedOn || '')
            setValue('Type', editFormData?.Type || '')
            setValue('Category', editFormData?.Category || '')
            setValue('RiskOwner', editFormData?.RiskOwner || '')
            setValue('ImpactedDepartnments', editFormData?.ImpactedDepartnments || [getDepartmentId])
            setValue('ImpactOfRisk', editFormData?.ImpactOfRisk || '')
            setValue('issueScore', editFormData?.ImpactOfRisk || '')
            setValue('mitigation', editFormData?.ImpactOfRisk || '')
        }
    }, [ isEditTrue, editFormData, setValue ])

    useEffect(() => {
        if (+riskId === +RiskDetailsById?.riskInformation?.id && RiskDetailsById?.riskInformation) {
            const data = RiskDetailsById?.riskInformation
            setformData(prevState => {
                return { ...prevState, Title: data?.title, Description: data?.description }
            })
            setValue('Title', data?.title || '')
            setValue('Description', data?.description || '')
        }
    }, [RiskDetailsById])
    const onValueChange = (value, name) => {
        if (name === MeetingTypes.RISK_OWNER || name === MeetingTypes.IMPACTED_DEPARTMENTS || name === MeetingTypes.CATEGORY || name === MeetingTypes.TYPE || name === MeetingTypes.SUGGESTED_MITIGATION) {
            setformData({ ...formData, [name]: value })
        } else if (name === MeetingTypes.IDENTIFIED_ON) {
            setformData({ ...formData, [name]: value?.toISOString() })
        } else {
            setformData({ ...formData, [name]: typeof value === 'string' ? value : value?.target?.value || '' })
        }
    }
    const handleRowClickOpenModal = (scoreData) => {
        setinitialIssueScore({
            Severity: scoreData?.Severity || null,
            Priority: scoreData?.Priority || null,
            IssueScore: scoreData?.RiskScore || null
        })
        setOpen(true)
    }

    const onValueChangeSeverityOfIssue = (e, name, ind) => {
        if (name === IssueTypes.SEVERITY_OF_ISSUE) {
            setIssueScore(issueScore?.map((mapData, mapIdx) => {
                if (mapIdx === ind) {
                    return { ...mapData, [name]: e }
                } else {
                    return mapData
                }
            }))
        }
    }

    const handleRemoveScore = (ind) => {
        setIssueScore(issueScore?.filter((_, filterIdx) => filterIdx !== ind))
    }

    const handleImageChange = (value, name) => {
        if (name === MeetingTypes.SUPPORTING_DOCUMENTS) {
            const newFiles = []

            value?.forEach((file) => {
                if (file) {
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        const fileObject = {
                            file: reader.result.split(',')[1],
                            contentType: file.type,
                            fileName: file.name
                        }

                        newFiles.push(fileObject)

                        if (newFiles.length === value.length) {
                            setformData((prevData) => ({
                                ...prevData,
                                SupportingDocuments: [...newFiles]
                            }))
                        }
                    }
                    reader.readAsDataURL(file)
                }
            })
        }
    }
    function getLabelByScore (score) {
        if (score >= 1 && score <= 5) return 'Very Low'
        if (score >= 6 && score <= 10) return 'Low'
        if (score >= 11 && score <= 15) return 'Medium'
        if (score >= 16 && score <= 20) return 'High'
        if (score >= 21 && score <= 25) return 'Very High'
        return 'Unknown'
    }

    const handleBoxClick = (x, y) => {
        const IssueScore = IssueTypes.ISSUE_SCROING_DATA[y][x]?.value
        const impact = x > 0 ? IssueTypes.ISSUE_SCROING_DATA[y][0]?.value : IssueScore
        const Probability = y < IssueTypes.ISSUE_SCROING_DATA.length - 1 ? IssueTypes.ISSUE_SCROING_DATA[IssueTypes.ISSUE_SCROING_DATA.length - 1][x]?.value : IssueScore
        setinitialIssueScore({
            Severity: getLabelByScore(impact),
            Priority: `${IssueTypes.xLabels[IssueTypes.PROBABILITY_VALUE.indexOf(Probability)]}`,
            IssueScore: `${
                 [ IssueTypes.ISSUE_SCORE_ONE, IssueTypes.ISSUE_SCORE_TWO, IssueTypes.ISSUE_SCORE_SIX ].includes(IssueScore)
                     ? IssueTypes.ISSUE_LEVEL_VERY_LOW
                     : [ IssueTypes.ISSUE_SCORE_THREE, IssueTypes.ISSUE_SCORE_FOUR, IssueTypes.ISSUE_SCORE_FIVE,
                         IssueTypes.ISSUE_SCORE_SEVEN, IssueTypes.ISSUE_SCORE_EIGHT,
                         IssueTypes.ISSUE_SCORE_ELEVEN, IssueTypes.ISSUE_SCORE_TWELVE, IssueTypes.ISSUE_SCORE_SIXTEEN ]
                         .includes(IssueScore)
                         ? IssueTypes.ISSUE_LEVEL_LOW
                         : [ IssueTypes.ISSUE_SCORE_NINE, IssueTypes.ISSUE_SCORE_THIRTEEN, IssueTypes.ISSUE_SCORE_SEVENTEEN ]
                             .includes(IssueScore)
                             ? IssueTypes.ISSUE_LEVEL_MEDIUM
                             : [ IssueTypes.ISSUE_SCORE_TEN, IssueTypes.ISSUE_SCORE_FOURTEEN, IssueTypes.ISSUE_SCORE_FIFTEEN,
                                 IssueTypes.ISSUE_SCORE_EIGHTEEN, IssueTypes.ISSUE_SCORE_NINETEEN,
                                 IssueTypes.ISSUE_SCORE_TWENTY_TWO, IssueTypes.ISSUE_SCORE_TWENTY_THREE ]
                                 .includes(IssueScore)
                                 ? IssueTypes.ISSUE_LEVEL_HIGH
                                 : [ IssueTypes.ISSUE_SCORE_TWENTY, IssueTypes.ISSUE_SCORE_TWENTY_ONE,
                                     IssueTypes.ISSUE_SCORE_TWENTY_FOUR, IssueTypes.ISSUE_SCORE_TWENTY_FIVE ]
                                     .includes(IssueScore)
                                     ? IssueTypes.ISSUE_LEVEL_VERY_HIGH
                                     : ''
               }`
        })
    }

    const handleThreeCrossBoxClick = (x, y) => {
        const IssueScore = IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][0]?.value : IssueScore
        const Probability = y < IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1
            ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1][x]?.value
            : IssueScore

        setinitialIssueScore({
            Severity: `${IssueTypes.Y_LABLES_THREE_CROSS[IssueTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]}`,
            Priority: `${IssueTypes.X_LABLES_THREE_CROSS[IssueTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(Probability)]}`,
            IssueScore: `${(IssueScore === IssueTypes.ISSUE_SCORE_ONE || IssueScore === IssueTypes.ISSUE_SCORE_TWO)
                ? IssueTypes.ISSUE_LEVEL_LOW
                : (IssueScore === IssueTypes.ISSUE_SCORE_THREE || IssueScore === IssueTypes.ISSUE_SCORE_FOUR)
                    ? IssueTypes.ISSUE_LEVEL_MEDIUM
                    : (IssueScore === IssueTypes.ISSUE_SCORE_SIX || IssueScore === IssueTypes.ISSUE_SCORE_NINE) &&
        IssueTypes.ISSUE_LEVEL_VERY_HIGH}`
        })
    }

    const handleCancel = () => {
        if (isEditTrue) {
            setIsEditTrue(false)
        } else {
            customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
        }
    }

    const handleSave = () => {
        // Create a new risk entry with updated values
        const newRiskValue = {
            id: 0,
            riskId: editFormData?.id,
            user: userName,
            status: issueScore?.length || 0,
            Severity: initialIssueScore?.Severity,
            Priority: initialIssueScore?.Priority,
            IssueScore: initialIssueScore?.IssueScore,
            impactOfRisk: ''
        }
        const existingIndex = issueScore.findIndex(
            (risk) => risk.riskId === editFormData?.id && risk.id === 0
        )

        let updatedRiskScore

        if (existingIndex !== -1) {
            updatedRiskScore = [
                ...issueScore.slice(0, existingIndex),
                newRiskValue,
                ...issueScore.slice(existingIndex + 1)
            ]
        } else {
            updatedRiskScore = [ ...issueScore, newRiskValue ]
        }
        setIssueScore(updatedRiskScore)
        setOpen(false)
    }

    // useEffect(() => {
    //     if (!issueScore.length) {
    //         setError('issueScore', { type: 'manual', message: 'Risk Score is required' })
    //     } else {
    //         clearErrors('issueScore')
    //     }

    //     if (!mitigationTasks[0]?.task?.trim().length) {
    //         setError('mitigationTasks', { type: 'manual', message: 'Mitigation Tasks is required' })
    //     } else {
    //         clearErrors('mitigationTasks')
    //     }
    // }, [ issueScore, mitigationTasks ]) // Watch dependencies

    // Add validation functions
    const validateRiskScore = () => {
        if (!issueScore || issueScore.length === 0) {
            setError('issueScore', { type: 'manual', message: 'Risk score selection is required' })
            return false
        }

        clearErrors('issueScore') // ✅ Clear error if everything is valid
        return true
    }

    const validateMitigationTasks = () => {
        if (!mitigationTasks || mitigationTasks.length === 0 || mitigationTasks[0].task.length === 0) {
            setError('mitigationTasks', { type: 'manual', message: 'Add at least one task' })
            return false
        }

        clearErrors('mitigationTasks') // ✅ Clear error if valid
        return true
    }

    useEffect(() => {
        if (issueScore?.length > 0) {
            clearErrors('issueScore') // ✅ Clear errors when issueScore is updated
        }
        if (mitigationTasks?.some(task => task.task.trim().length > 0)) {
            clearErrors('mitigationTasks') // ✅ Clear errors when mitigationTasks are valid
        }
    }, [ issueScore, mitigationTasks ])

    const handleAddRisk = async (value) => {
        // Validate all fields including our custom ones
        const isValid = await trigger()
        const isRiskScoreValid = validateRiskScore()
        const isMitigationValid = validateMitigationTasks()

        if (!isValid || !isRiskScoreValid || !isMitigationValid) {
            return
        }

        if (!issueScore.length || !mitigationTasks[0]?.task?.trim().length) {
            return
        }

        try {
            const selectedFiles = formData?.SupportingDocuments || []
            const addIssueFormate = {
                IssueId: isEditTrue ? editFormData?.id : 0,
                SourceId: riskId ? RiskDetailsById?.riskInformation.id : 0,
                // Title: formData?.Title,
                // Description: formData?.Description,
                Title: formData?.Title === undefined || formData?.Title === '' ? '' : formData?.Title,
                Description: formData?.Description === undefined || formData?.Description === '' ? '' : formData?.Description,
                IdentifiedOn: formData?.IdentifiedOn,
                SourceIssueId: internalExternal === 'New' ? 1 : 2,
                IssueType: formData?.Type,
                // Category: formData?.Category,
                ImpactedDepartmentIds: formData?.ImpactedDepartnments,
                RaisedDepartmentId: loginId,
                OwnerDepartmentId: formData?.RiskOwner,
                Scores: issueScore?.map((mapData, mapIndex) => {
                    return {
                        id: mapData?.id ? mapData?.id : 0,
                        riskId: isEditTrue ? editFormData?.id : 0,
                        levelId: 1,
                        userId: mapData?.userId || loginId,
                        user: mapData?.user || userName,
                        impact: mapData?.Priority,
                        probability: mapData?.Severity,
                        riskScore: mapData?.IssueScore,
                        impactOfRisk: mapData?.SeverityOfIssue,
                        probabilityJustification: '',
                        createdBy: loginId,
                        createdAt: new Date()?.toISOString(),
                        modifiedBy: loginId,
                        modifiedAt: new Date()?.toISOString(),
                        status: 1
                    }
                }),
                ResolutionPlan: mitigationTasks?.map(mapDt => {
                    return {
                        id: mapDt.id ? mapDt.id : 0,
                        riskid: mapDt.riskId ? mapDt.riskId : 0,
                        name: mapDt?.task,
                        startDate: typeof mapDt?.startDate === 'object' ? mapDt?.startDate?.toISOString() : mapDt?.startDate,
                        endDate: typeof mapDt?.endDate === 'object' ? mapDt?.endDate?.toISOString() : mapDt?.endDate,
                        departmentId: '',
                        actions: mapDt.actions || '',
                        responsible: '',
                        createdBy: mapDt?.createdBy || loginId,
                        createdAt: new Date().toISOString(),
                        modifiedBy: mapDt?.modifiedBy || loginId,
                        modifiedAt: new Date().toISOString(),
                        status: mapDt.status
                    }
                }),
                Level1: riskInfoData?.level1 ? riskInfoData?.level1 : 8,
                Level2: riskInfoData?.level2 ? riskInfoData?.level2 : 8,
                CreatedBy: isEditTrue ? editFormData?.CreatedBy : loginId,
                CreatedAt: isEditTrue ? editFormData?.CreatedDate : new Date().toISOString(),
                ModifiedBy: loginId,
                ModifiedAt: new Date().toISOString(),
                Status: STATUS_ENUMS.Analyze
            }

            const formValue = new FormData()

            Object.entries(addIssueFormate).forEach(([ key, value ]) => {
                if (Array.isArray(value)) {
                    if (key === 'Scores') {
                        value?.forEach((score, index) => {
                            Object?.entries(score)?.forEach(([ scoreKey, scoreValue ]) => {
                                formValue?.append(`Scores[${index}].${scoreKey}`, scoreValue)
                            })
                        })
                    } else if (key === 'ImpactedDepartmentIds') {
                        addIssueFormate?.ImpactedDepartmentIds?.forEach((deptId, index) => {
                            formValue?.append(`ImpactedDepartmentIds[${index}]`, deptId)
                        })
                    } else if (key === 'ResolutionPlan') {
                        addIssueFormate?.ResolutionPlan?.forEach((task, index) => {
                            Object?.entries(task)?.forEach(([ taskKey, taskValue ]) => {
                                formValue?.append(`ResolutionPlan[${index}].${taskKey}`, taskValue)
                            })
                        })
                    } else {
                        value?.forEach(item => formValue.append(key, item))
                    }
                } else {
                    formValue?.append(key, value)
                }
            })

            selectedFiles?.forEach((task, index) => {
                Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                    formValue.append(`SupportingDocuments[${index}].${taskKey}`, taskValue)
                })
            })
            setLoading(true)
            await CreateIssue(loginId, formValue)
                .then((res) => {
                    if (res.data === 'Failed to add risk: Risk Withdrawn') {
                        setOpenWithdrawnPopup(true)
                    } else if (res?.data) {
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{value.replace('[ID]', res?.data)}</p></p>, {
                            position: 'top-right', theme: 'light'
                        })

                        navigate(`/GRC${RoutePath.ISSUE.URI}/${IssueTypes.ISSUE_TAB.ANALYZE_AND_PLAN}`, { state: { riskDetails: { issueId: res?.data } } })
                    } else {
                        const warningMessage = res?.err?.response?.data?.errors
                        if (warningMessage.length > 0) {
                            warningMessage.forEach((message) => {
                                toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                            })
                        } else {
                            toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                        }
                    }
                    setLoading(false)
                })
                .catch((err) => {
                    const warningMessage = err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                    }
                    setLoading(false)
                    console.warn(err)
                })
        } catch (error) {
            console.warn('Error adding risk:', error)
        }
    }

    const getAllIssueTypes = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllIssueTypes')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllCategories = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllDepartments = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + `/user/GetDepatmentsByOrganization?organizationId=${orgId}`)
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === IssueTypes.CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === IssueTypes.CHIP_LOW) {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === IssueTypes.CHIP_MEDIUM) {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === IssueTypes.CHIP_HIGH) {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === IssueTypes.CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    const handleScoringLevel = (event) => {
        setScoringLevel(event)
    }

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllIssueTypes()
                setIssueTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                const types = await getAllDepartments()
                setImpactedDepartments(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])
    const userDepartment = localStorage.getItem('department')
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    return (
        <div className={isEditTrue ? 'w-full h-[100%] flex flex-col bg-background overflow-auto' : 'add-risk-container overflow-auto'}>
            <Loading isLoading={loading} />
            <div className='add-risk-content flex flex-col'>
                <Card className='border-[0px] h-full risk-card'>
                    <CardContent className='p-3 h-full'>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Issue Summary</p>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <Input
                                        label="Issue Title"
                                        register={register}
                                        value={formData?.Title}
                                        type="text"
                                        placeholder="Enter Issue Title"
                                        onValueChange={onValueChange}
                                        name="Title"
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{
                                            required: 'This field is Required',
                                            validate: (value) => {
                                                const regex = /^\S+(?: \S+)*$/
                                                if (!regex.test(value)) {
                                                    return 'Remove unwanted spaces'
                                                }
                                            }
                                        }

                                        }
                                    />
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div style={{ marginBottom: '2%' }}>
                                    <Textarea label="Description" className={cn('ml-[0px] border-2 border-grey-200')} register={register} value={formData?.Description} type="text" placeholder="Enter Description" onValueChange={onValueChange} name="Description" errors={errors} control={control}
                                        required
                                        rules={{
                                            required: 'This field is Required'
                                            // validate: (value) => {
                                            //     const regex = /^\S+(?: \S+)*$/
                                            //     if (!regex.test(value)) {
                                            //         return 'Remove unwanted spaces'
                                            //     }
                                            // }
                                        }} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    {/* <DateInput value={formData?.IdentifiedOn} name='IdentifiedOn' register={register} onValueChange={onValueChange} label={t('Identified On')} required /> */}
                                    <DatePickerInput
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{ required: t('IdentifiedOn date is required') }}
                                        name='IdentifiedOn'
                                        maxDate={new Date()}
                                        label={t('Identified On')}
                                        register={register}
                                        type="text"
                                        value={formData?.IdentifiedOn || ''}
                                        onValueChange={onValueChange}
                                    />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div className='mt-1'>
                                    <label className={cn('grc-label block mb-1')}>Source of Issue<span className='text-danger'>*</span></label>
                                    <RadioGroup onValueChange={handleCheckRadioBox} value={internalExternal} className='flex mt-3' >
                                        <div className='flex items-center space-x-2'>
                                            <RadioGroupItem value="New" />
                                            <label className='text-subMenu'>New</label>
                                        </div>
                                        <div className='flex items-center space-x-2'>
                                            <RadioGroupItem value="Risk" />
                                            <label className='text-subMenu'>Risk</label>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Issue Type" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="Type" placeholder="Select Issue Type" onValueChange={onValueChange} value={formData?.Type} options={issueTypes.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <MultiSelectInputDisable required rules={{
                                        validate: value => {
                                            if (value.length > 0 || value !== null) {
                                                return true
                                            }
                                            return 'Impacted Department is required'
                                        }
                                    }} label={t('Impacted Department')} control={control} errors={errors} name="ImpactedDepartnments" placeholder={t('Select Impacted Department')} defaultValue={formData?.ImpactedDepartnments} value={formData?.ImpactedDepartnments} options={impactedDepartments?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status, disable: data?.id === getDepartmentId }))}
                                    onValueChange={(value) => {
                                        onValueChange(value, 'ImpactedDepartnments')
                                        setValue('ImpactedDepartnments', value, { shouldValidate: true })
                                    }} />
                                </div>
                            </Box>
                            {/* <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Category" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="Category" placeholder="Select Category" onValueChange={onValueChange} value={formData?.Category} options={allCategories.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box> */}
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Issue Owner" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="RiskOwner" placeholder="Owner" onValueChange={onValueChange} value={formData?.RiskOwner} options={impactedDepartments.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box>
                            <Box gridColumn="span 9">
                                <MultiFileSelect
                                    name="SupportingDocuments"
                                    label="Supporting Documents"
                                    register={register}
                                    errors={errors}
                                    required={false}
                                    className='!w-[92%]'
                                    onValueChange={handleImageChange}
                                    defaultValue={formData?.SupportingDocuments}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Issue Scoring</p>
                            <span className='text-danger text-[25px]'>*</span>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ px: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 7">
                                <div className='flex flex-row justify-end'>
                                    <Button
                                        variant='outlined'
                                        component='label'
                                        size='small'
                                        // disabled={(!Object.values(userRoles).some(value => value === 'Risk Manager')) || ((riskInfoData?.level1 === 8 && riskInfoData?.level2 === 8) ? issueScore?.length === 2 : (riskInfoData?.level1 === 3 && riskInfoData?.level2 === 8) ? issueScore?.length === 3 : false)}
                                        disabled={(riskInfoData?.level1 === RiskTypes.RISK_INFORMATION_STATUS_ID && riskInfoData?.level2 === RiskTypes.RISK_INFORMATION_STATUS_ID) ? (issueScore?.length === 2 || !Object.values(userRoles).some(value => value === 'Risk Manager')) : (riskInfoData?.level1 === RiskTypes.ANALYZE_STATUS_ID && riskInfoData?.level2 === RiskTypes.RISK_INFORMATION_STATUS_ID) ? (issueScore?.length === 3 || !Object.values(userRoles).some(value => value === 'Risk Manager')) : false}
                                        style={{ marginTop: '2rem', marginBottom: '20px', height: '40px', fontWeight: 'bold', fontSize: '12px', color: 'hsl(var(--primary))', padding: '12px', border: '2px solid hsl(var(--primary))' }}
                                        onClick={() => { setOpen(true); setinitialIssueScore(issueScore) }}
                                    >
                                        <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                                            <IoAdd className="mr-2" size={15} /> Add Score
                                        </span>
                                    </Button>
                                </div>
                                <div style={{ marginBottom: '2%' }}>
                                    <table className="risk-table">
                                        <thead>
                                            <tr>
                                                <th>Users</th>
                                                <th>Priority</th>
                                                <th>Severity</th>
                                                <th>Issue Level</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {issueScore?.map((mapData, mapIdx) => {
                                                return <tr key={mapIdx}>
                                                    <td className='flex flex-col justify-center'>
                                                        <span>{mapData?.user === userName ? 'You' : mapData?.user || '-'}</span>
                                                        <span className='text-destructive'>{mapData?.role || '-'}</span>
                                                    </td>
                                                    <td className={cn('underline underline-offset-2', mapData?.id === 0 ? 'cursor-pointer' : '')} onClick={() => mapData?.id === 0 && handleRowClickOpenModal(mapData) }>{mapData?.Priority || '-'}</td>
                                                    <td className={cn('underline underline-offset-2', mapData?.id === 0 ? 'cursor-pointer' : '')} onClick={() => mapData?.id === 0 && handleRowClickOpenModal(mapData) }>{mapData?.Severity || '-'}</td>
                                                    <td>
                                                        {mapData?.IssueScore ? <span className={'risk-level'} style={{ backgroundColor: chipColorStyle(mapData?.IssueScore) }}>{mapData?.IssueScore || '-'}</span> : '-'}
                                                    </td>
                                                    <td >{mapData?.id === 0
                                                        ? (<Tooltip title="Delete Score" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }} style={{ width: 'fit-content !important' }}>
                                                            <span><RiDeleteBin5Line onClick={() => { handleRemoveScore(mapIdx) }} size={24} className='cursor-pointer' color='hsl(var(--destructive))' /></span>
                                                        </Tooltip>
                                                        )
                                                        : ('-')}
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                    {errors.issueScore && (
                                        <p className="grc-error-msg text-danger">{errors.issueScore.message}</p>
                                    )}
                                </div>
                            </Box>
                        </Box>

                        <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            {issueScore?.map((mapData, mapIdx) => <Box key={mapIdx} gridColumn={`span ${issueScore?.length > 1 ? 12 / issueScore?.length : 7}`}>
                                <div className='relative' style={{ marginBottom: '2%' }}>
                                    <Textarea disabled={mapData?.id !== 0} className={cn('ml-[0px]')} label="Severity of Issue" rules={{
                                        validate: (value) => {
                                            if (!value) return t('This field is required')
                                            const regex = /^\S+(?: \S+)*$/
                                            if (!regex.test(value)) {
                                                return 'Remove unwanted spaces'
                                            }
                                            return true
                                        }
                                    }} register={register} value={mapData?.SeverityOfIssue} type="text" placeholder="Enter Severity of Issue" onValueChange={(e) => {
                                        const value = e.slice(0, 250)
                                        onValueChangeSeverityOfIssue(value, 'SeverityOfIssue', mapIdx)
                                    }} name="SeverityOfIssue" errors={errors} control={control} required={mapIdx === 0} maxLength={250} />
                                    <div className={cn('absolute bottom-[6px] right-[10px] text-muted text-[10px]', mapData?.SeverityOfIssue?.length > 250 ? '!text-danger' : 'text-muted')}>{mapData?.SeverityOfIssue?.length || 0}/250</div>
                                </div>
                            </Box>)}
                        </Box>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Resolution Plan</p>
                            <span className='text-danger text-[25px]'>*</span>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ p: 3 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 10">
                                <AddOnTable
                                    header={headerArray}
                                    setTasks={setMitiationTasks}
                                    tasks={mitigationTasks}
                                    riskDeails={editFormData}
                                    control={control}
                                    errors={errors}
                                />
                            </Box>
                        </Box>
                        {errors && mitigationTasks && errors.mitigationTasks && <p className='grc-error-msg text-danger p-7'>{errors && errors.mitigationTasks?.message}</p>}
                    </CardContent>
                </Card>
                <Dialog
                    maxWidth
                    open={open}
                    onClose={handleClose}
                >
                    <Box sx={{ width: 1000 }} >
                        <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Choose Issue Score</div>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '45%', padding: '30px' }}>
                                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <img src='/Assets/Priority.svg' style={{ height: '260px' }} alt="Impact" />
                                        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            {heatMapSelection
                                                ? <Heatmap
                                                    xLabels={IssueTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                    yLabels={IssueTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                    xLabelsLocation={'bottom'}
                                                    xLabelWidth={50}
                                                    data={IssueTypes.ISSUE_SCROING_DATA}
                                                    squares
                                                    height={50}
                                                    onClick={(x, y) => {
                                                        handleBoxClick(x, y)
                                                        setSelectedBox({ x, y })
                                                    }}
                                                    cellStyle={(background, value, min, max, data, x, y) => ({
                                                        fontSize: '12.5px',
                                                        backgroundColor: value?.color,
                                                        color: '#fff',
                                                        border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                    })}
                                                    // cellRender={value => value && <div>{value.value}</div>}
                                                />
                                                : <Heatmap
                                                    xLabels={IssueTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                    yLabels={IssueTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                    xLabelsLocation={'bottom'}
                                                    xLabelWidth={50}
                                                    data={IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS}
                                                    squares
                                                    height={50}
                                                    onClick={(x, y) => {
                                                        handleThreeCrossBoxClick(x, y)
                                                        setSelectedBox({ x, y })
                                                    }}
                                                    cellStyle={(background, value, min, max, data, x, y) => ({
                                                        fontSize: '12.5px',
                                                        backgroundColor: value?.color,
                                                        color: '#fff',
                                                        border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                    })}
                                                />}
                                        </div>
                                    </div>
                                    <img src='/Assets/Severity.svg' style={{ paddingLeft: '60px', marginLeft: '21px', paddingTop: '20px', marginBottom: '-40px' }} alt="Impact" />
                                </div>
                                <span style={{
                                    display: 'inline-block',
                                    width: '2px',
                                    backgroundColor: 'hsl(var(--primary-foreground))',
                                    margin: ' 0 10px',
                                    height: ' 22em'
                                }} />
                                <div style={{ width: '55%', marginLeft: '1rem', display: 'flex', flexDirection: 'column' }}>
                                    <Box display="grid" className='w-[100%] h-full'>
                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                            <p style={{ fontWeight: 'bold', marginRight: '1rem', fontSize: '12px' }}>Issue Level</p>
                                            {heatMapSelection
                                                ? IssueTypes.ISSUE_RATINNG?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                                : IssueTypes.ISSUE_RATINNG_THREE_CROSS?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', marginRight: '0.2rem', fontWeight: 'bold', color: 'hsl(var(--primary))' }}>
                                                Priority :
                                            </h4>
                                            <span>
                                                {initialIssueScore?.Severity || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', fontWeight: 'bold', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                            Severity :
                                            </h4>
                                            <span>
                                                {initialIssueScore?.Priority || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className=" max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', fontWeight: 'bold', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                            Issue Level :
                                            </h4>
                                            <span>
                                                <Chip
                                                    key={initialIssueScore?.IssueScore || ''}
                                                    label={initialIssueScore?.IssueScore || ''}
                                                    sx={{
                                                        width: '90px',
                                                        // height: '90%',
                                                        color: 'hsl(var(--foreground))',
                                                        backgroundColor: chipColorStyle(initialIssueScore?.IssueScore)
                                                    }}

                                                />
                                            </span>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>

                            <div className='d-flex content-end'>
                                <SaveCancelButton handleCancel={handleClose} handleSave={handleSave} readOnly={!initialIssueScore?.Severity} />
                            </div>
                        </DialogActions>
                    </Box>
                </Dialog>
                <Dialog
                    maxWidth
                    open={openWithdrawnPopup}
                    onClose={handleClose}
                >
                    <Box sx={{ width: 400 }} >
                        <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Warning</div>
                        </DialogTitle>
                        <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                            <p className='text-muted pt-[24px] text-[14px]'>
                                {`This Risk has been already withdrawn. ${'You'} can't proceed further`}
                            </p>
                        </DialogContent>
                        <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <div className='d-flex content-end'>
                                <Button
                                    variant='outline'
                                    style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                    onClick={() => {
                                        customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                                    }}
                                >
                                    {t('Close')}
                                </Button>
                            </div>
                        </DialogActions>
                    </Box>
                </Dialog>
            </div>
            {(isEditTrue && ((riskInfo?.level1 === 8 && riskInfo?.department === userDepartment) || (riskInfo?.ownerDepartmentId === userDepartment && riskInfo.level2 === 8))) || (riskInfo?.department === userDepartment && riskInfo.status === 1 && ((riskInfo.level1 === STATUS_ENUMS.Rejected && riskInfo.level2 === STATUS_ENUMS.Pending) || (riskInfo.level1 === STATUS_ENUMS.Approved && riskInfo.level2 === STATUS_ENUMS.Rejected))) || location.pathname.includes('add-issue')
                ? <div style={{ borderTop: '2px solid hsl(var(--primary-foreground))' }} className='flex-shrink-0 h-[60px] relative flex-grow'>
                    <SaveCancelButton isEditTrue={isEditTrue} handleCancel={handleCancel} loading={isSubmitting || isLoading || loading} handleSave={() => {
                        validateRiskScore()
                        validateMitigationTasks()
                        handleSubmit(() => {
                            handleAddRisk(riskId ? 'Risk Converted to Issue successfully [ID]' : 'Issue [ID] has been successfully created')
                        })()
                    }} />
                </div>
                : null}
        </div>
    )
}

export default AddIssue
